module.exports = __webpack_public_path__ + "VE.png?1319ff138c5d6779e18d3a1b70f1faa5";